import { apiClients } from '../config/apiClient';

export const contactAPI = {
  // Enviar formulario de contacto
  async submitContactForm(formData) {
    try {
      const response = await apiClients.contact.post('/', formData);
      return response.data;
    } catch (error) {
      console.error('Error submitting contact form:', error);
      throw new Error(error.response?.data?.detail || 'Error al enviar el mensaje');
    }
  },
};
